module.exports = __webpack_public_path__ + "img/plain.80a569bf.svg";